import { ITournament } from "@/redux/tournaments/types";

export function isTournamentPast(tournament: ITournament): boolean {
  const now = new Date();
  
  try {
    const [hours, minutes] = tournament.end_time.split(':').map(Number);
    
    if (isNaN(hours) || isNaN(minutes)) {
      console.warn(`Failed to parse end time: ${tournament.end_time}`);
      return false;
    }
    
    let tournamentDate: Date;
    
    if (tournament.date.includes('-')) {
      tournamentDate = new Date(tournament.date);
      if (isNaN(tournamentDate.getTime())) {
        const [year, month, day] = tournament.date.split('-').map(Number);
        tournamentDate = new Date(year, month - 1, day, hours, minutes);
      } else {
        tournamentDate.setHours(hours, minutes, 0, 0);
      }
    } else if (tournament.date.includes('.')) {
      const [day, month, year] = tournament.date.split('.').map(Number);
      tournamentDate = new Date(year, month - 1, day, hours, minutes);
    } else {
      tournamentDate = new Date(`${tournament.date}T${tournament.end_time}:00`);
      
      if (isNaN(tournamentDate.getTime())) {
        tournamentDate = new Date(tournament.date);
        tournamentDate.setHours(hours, minutes, 0, 0);
      }
    }
    
    if (isNaN(tournamentDate.getTime())) {
      console.warn(`Failed to parse tournament date: ${tournament.date} ${tournament.end_time}`);
      return false;
    }
    
    // Скрываем за 30 минут до окончания (как в аренде кортов)
    tournamentDate.setMinutes(tournamentDate.getMinutes() - 30);
    return tournamentDate < now;
  } catch (error) {
    console.error(`Error checking if tournament is past:`, error);
    return false;
  }
}

export function filterPastTournaments(tournaments: ITournament[]): ITournament[] {
  return tournaments.filter((tournament) => !isTournamentPast(tournament));
}
